import {remCalc} from '../../../_utils'

const productDetailsPage = {
    ProductDetailsPage: {
        baseStyle: ({headerSize}) => ({
            container: {
                w: '100%',
                h: 'auto',
                pt: {
                    base: `${headerSize.base}px`,
                    sm: `${headerSize.sm}px`,
                    md: `${headerSize.md}px`,
                    lg: `${headerSize.lg}px`,
                    xl: `${headerSize.xl}px`,
                    '2xl': `${headerSize['2xl']}px`,
                },
                alignItems: 'flex-start',
            },
        }),
    },
}

export default productDetailsPage
